import { Button, Result } from 'antd';
import { useNavigate } from 'react-router';
import { AppRole } from '../../constants/api';
import { useApp } from '../../store/appStores';

export const NoTpvAccess = () => {
  const navigate = useNavigate();
  const userInfo = useApp((s) => s.userInfo);

  return (
    <Result
      status={403}
      title="Ups"
      subTitle="No tienes acceso a ningún TPV"
      extra={
        userInfo.role === AppRole.ADMIN ? <Button onClick={() => navigate('/settings/users')}>Configurar</Button> : null
      }
    />
  );
};
